// extracted by mini-css-extract-plugin
export default {"date_wrapper":"styles_date_wrapper__RuPXO","empty_table":"styles_empty_table__Umrue","title":"styles_title__BRh8B","description":"styles_description__ZM04p"};